export default __webpack_public_path__ + "static/media/zeston-app.efcbb115.jpg";